import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(productBrandStyles, {
    nameLink: {
        typographyProps: {
            size: TYPOGRAPHY.size.base,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            color: ${getColor("text.main")};
            text-transform: uppercase;
            &:hover {
                text-decoration: underline;
            }
        `,
    },
});
